const menuData = [
  {
    id: "coffee",
    category: "Coffee",
    emoji: "☕",
    items: [
      { name: "Hot Coffee",          price: 50  },
      { name: "Cold Coffee",         price: 120 },
      { name: "Hazelnut Coffee",     price: 120 },
      { name: "Butterscotch Coffee", price: 120 },
      { name: "Irish Coffee",        price: 120 },
    ],
  },
  {
    id: "tea",
    category: "Tea",
    emoji: "🍵",
    items: [
      { name: "Milk Tea",          price: 30  },
      { name: "Black Tea",         price: 40  },
      { name: "Masala Tea",        price: 40  },
      { name: "Lemon Tea",         price: 40  },
      { name: "Ginger Honey Tea",  price: 100 },
      { name: "Green Tea",         price: 100 },
    ],
  },
  {
    id: "shakes",
    category: "Shakes & Coolers",
    emoji: "🥤",
    items: [
      { name: "Strawberry Shake",  price: 120 },
      { name: "KitKat Shake",      price: 120 },
      { name: "Oreo Shake",        price: 120 },
      { name: "Chocolate Shake",   price: 120 },
      { name: "Virgin Mojito",     price: 140 },
      { name: "Classic Mojito",    price: 140 },
      { name: "Watermelon Mint",   price: 140 },
    ],
  },
  {
    id: "snacks",
    category: "Snacks",
    emoji: "🍟",
    items: [
      { name: "French Fries",         price: 120 },
      { name: "Peri Peri Fries",      price: 140 },
      { name: "Loaded Fries",         price: 140 },
      { name: "Chilli Cheese Fries",  price: 140 },
    ],
  },
  {
    id: "fastfood",
    category: "Fast Food",
    emoji: "🍜",
    items: [
      { name: "Chicken Chowmein", price: 140 },
      { name: "Egg Chowmein",     price: 120 },
      { name: "Veg Chowmein",     price: 100 },
    ],
  },
];

export default menuData;
